import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Document_FieldsFragment, Estate, EstateInputDataInstance_FieldsFragment } from 'queries';

import AssignedDocumentsForSignature from './assigned-documents-for-signature';
import AssignedGeneratedDocuments from './assigned-generated-documents';
import AssignedSearchResultDocuments from './assigned-search-result-documents';
import AssignedTaskMatterInfoRequiredDocsForm from './assigned-task-matter-info-required-docs-form';

const useStyles = makeStyles(() => ({
  emptyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '8px',
  },
  documentsContainer: {
    marginBottom: '30px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    marginTop: '24px',
  },
  subtitle: {
    fontSize: '14px',
    marginTop: '12px',
  },
}));

type Props = {
  documents: Document_FieldsFragment[];
  estate: Estate;
  estateInputDataInstances: EstateInputDataInstance_FieldsFragment[];
  onRefreshDocuments: () => void;
  refetchEstateInputDataInstances: () => void;
};

const AssignedTaskDocuments = ({
  documents,
  estate,
  estateInputDataInstances,
  onRefreshDocuments,
  refetchEstateInputDataInstances,
}: Props) => {
  const classes = useStyles();

  const documentsForSignature = documents.filter((document) => document.isFilePendingSignature);
  const generatedDocuments = documents.filter(
    (document) => document.isFileGeneratedAndSignedIfNeeded,
  );
  const searchResultDocuments = documents.filter(
    (document) => document.isFileSearchResultAndSignedIfNeeded,
  );

  return (
    <>
      {estateInputDataInstances.length !== 0 && (
        <div className={classes.documentsContainer}>
          <AssignedTaskMatterInfoRequiredDocsForm
            estate={estate}
            estateInputDataInstances={estateInputDataInstances}
            refetchEstateInputDataInstances={refetchEstateInputDataInstances}
          />
        </div>
      )}
      {documentsForSignature.length > 0 && (
        <div className={classes.documentsContainer}>
          <AssignedDocumentsForSignature
            documents={documentsForSignature}
            onRefreshDocuments={onRefreshDocuments}
          />
        </div>
      )}
      {generatedDocuments.length > 0 && (
        <div className={classes.documentsContainer}>
          <AssignedGeneratedDocuments
            documents={generatedDocuments}
            onRefreshDocuments={onRefreshDocuments}
          />
        </div>
      )}
      {searchResultDocuments.length > 0 && (
        <div className={classes.documentsContainer}>
          <AssignedSearchResultDocuments
            documents={searchResultDocuments}
            onRefreshDocuments={onRefreshDocuments}
          />
        </div>
      )}
      {estateInputDataInstances.length === 0 &&
        !documentsForSignature.length &&
        !generatedDocuments.length &&
        !searchResultDocuments.length && (
          <Box className={classes.emptyContainer}>
            <img src="/estate-vault-empty-image.svg" alt="empty documents" />
            <Typography className={classes.title}>Nothing to show here yet</Typography>
            <Typography className={classes.subtitle}>All files will show here.</Typography>
          </Box>
        )}
    </>
  );
};

export default AssignedTaskDocuments;
